import { render } from "./WorkflowInput.vue?vue&type=template&id=fab86a24&ts=true"
import script from "./WorkflowInput.vue?vue&type=script&lang=ts"
export * from "./WorkflowInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__